import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
  InMemoryBoolean,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from '@/plugins/i18n';

const ActivityStatusHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("ActivityStatus/Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    type: new InMemoryString("ActivityStatus/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    type: new InMemoryString("ActivityStatus/Name"),
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.name",
    type: new InMemoryString("Translations[]/Name", {
      getString: (item) => translate2(item.ActivityStatus, "Name"),
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.employer_files.code",
    type: new InMemoryString("ActivityStatus/Code"),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new InMemoryHeader({
    type: new InMemoryString("Description", {
      getHtml: (item, type) => {
        return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
        );
      }
    }),
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.description",
    type: new InMemoryString("ActivityStatus/Translations[]/Description", {
      getString: (item) => translate2(item.ActivityStatus, "Description"),
      getHtml: (item, type) => {
        return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
        );
      }
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.activitystatus.maintained_benefits",
    type: new InMemoryString("MaintainedBenefits", {
      getString: (item) => item.CoverageIdentities?item.CoverageIdentities.map(o=>`${translate2(o, "Name")} (${translate2(o, "Description")})`).join(", "):"",
      getHtml: (item, type) => {
        return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
        );
    }
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.activitystatus.duration",
    type: new InMemoryString("Duration", {
      getString: (item) => {
        if (item.Duration === undefined || item.Duration === null || item.DurationUnit === undefined || item.DurationUnit === null) {
          return "";
        }
        return `${item.Duration} x ${item.DurationUnit}`
      },
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.activitystatus.end_of_status_event",
    type: new InMemoryString("EndOfStatusEvent", {
      getString: (item) => {
        if (item.EndOfStatusEvent === undefined || item.EndOfStatusEvent === null) {
          return "";
        }
        return i18n.t("enums." + item.EndOfStatusEvent);
      }
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
];
export default ActivityStatusHeaders;
